"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClientExperiences() {
  const testimonials = [{
    quote: "IMI Elite handled our timeshare exit with absolute transparency. We are finally free from the annual fees.",
    name: "ROBERTO M.",
    meta: "Property Owner, Cabo San Lucas"
  }, {
    quote: "Their rental management increased our yield by 22% in the first year. Professionalism at its finest.",
    name: "SARAH JENKINS",
    meta: "Fractional Owner, Palmilla Dunes"
  }, {
    quote: "The concierge services are unparalleled. From private chefs to yacht charters, every detail was flawless.",
    name: "DAVID ARNAULT",
    meta: "Luxury Traveler, Seasonal Resident"
  }, {
    quote: "Navigating cross-border real estate was daunting until we met the IMI team. They are true experts.",
    name: "MICHAEL CHENG",
    meta: "Investor, Vancouver & Los Cabos"
  }, {
    quote: "Legal compliance and SAT registration were handled seamlessly. I trust them with my entire portfolio.",
    name: "ELENA RODRIGUEZ",
    meta: "Commercial Partner, Baja Development"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setActiveIndex(prev => (prev + 1) % testimonials.length);
        setIsFading(false);
      }, 1200);
    }, 8000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  const handleSelect = (i: number) => {
    if (i === activeIndex) return;
    setIsFading(true);
    setTimeout(() => {
      setActiveIndex(i);
      setIsFading(false);
    }, 1200);
  };
  const handlePrev = () => {
    handleSelect((activeIndex - 1 + testimonials.length) % testimonials.length);
  };
  const handleNext = () => {
    handleSelect((activeIndex + 1) % testimonials.length);
  };
  const current = testimonials[activeIndex];
  return <section data-section-id="3731" id="client-experiences" ref={sectionRef} className="relative bg-background text-foreground py-32 md:py-44 lg:py-[180px] px-6 md:px-10 overflow-hidden">
      {}
      <Button variant="ghost" onClick={handlePrev} aria-label="Previous testimonial" className="hidden lg:flex absolute left-8 top-1/2 -translate-y-1/2 h-auto px-2 py-2 hover:bg-transparent rounded-md">
        <span className="text-[11px] tracking-[0.4em] text-muted-foreground hover:text-primary transition-colors duration-500 font-mono" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          PREV
        </span>
      </Button>

      <Button variant="ghost" onClick={handleNext} aria-label="Next testimonial" className="hidden lg:flex absolute right-8 top-1/2 -translate-y-1/2 h-auto px-2 py-2 hover:bg-transparent rounded-md">
        <span className="text-[11px] tracking-[0.4em] text-muted-foreground hover:text-primary transition-colors duration-500 font-mono" style={{
        writingMode: "vertical-rl"
      }}>
          NEXT
        </span>
      </Button>

      <div className="max-w-6xl mx-auto">
        {}
        <div className={`flex items-center justify-center gap-6 mb-20 md:mb-28 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="block w-10 h-px bg-primary" />
          <span className="text-[11px] md:text-xs tracking-[0.5em] text-primary font-mono font-semibold uppercase">
            Client Experiences
          </span>
          <span className="block w-10 h-px bg-primary" />
        </div>

        {}
        <div className={`relative transition-opacity duration-1200 ${isFading ? "opacity-0" : "opacity-100"}`} style={{
        transitionDuration: "1200ms"
      }}>
          <div className="relative max-w-[880px] mx-auto px-4 md:px-12">
            {}
            <span aria-hidden="true" className="absolute -top-10 md:-top-14 left-0 md:-left-2 font-serif italic text-primary/20 leading-none select-none" style={{
            fontSize: "96px"
          }}>
              &ldquo;
            </span>

            <blockquote className="relative">
              <p className="font-serif italic font-light text-foreground text-2xl md:text-4xl lg:text-[42px] leading-[1.4] text-center">
                {current.quote}
              </p>
            </blockquote>

            {}
            <div className="flex justify-center my-12 md:my-14">
              <span className="block w-[60px] h-px bg-primary" />
            </div>

            {}
            <div className="text-center space-y-2">
              <div className="text-sm tracking-[0.35em] text-foreground font-default font-semibold uppercase">
                {current.name}
              </div>
              <div className="text-[13px] tracking-[0.15em] text-slate-muted font-default font-normal">
                {current.meta}
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="flex items-center justify-center gap-4 mt-16 md:mt-20">
          {testimonials.map((_, i) => <Button key={i} data-index={i} variant="ghost" size="icon" onClick={() => handleSelect(i)} aria-label={`Show testimonial ${i + 1}`} className="h-6 w-6 p-0 hover:bg-transparent rounded-md">
              <span className={`block transition-all duration-700 rounded-md ${i === activeIndex ? "h-[8px] w-[8px] bg-primary" : "h-[8px] w-[8px] bg-transparent border border-border"}`} />
            </Button>)}
        </div>

        {}
        <div className={`mt-24 md:mt-32 text-center transition-all duration-1000 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="text-xs tracking-[0.3em] text-slate-muted font-mono font-medium uppercase"><span className="mr-3 text-primary" data-ast-id="f:/src/pages/Home/sections/ClientExperiences.tsx|sig:42m78e" data-ast-start="6047" data-ast-end="6208">— </span>&nbsp;29 years Expertise<span className="mx-3 text-primary/70" data-ast-id="f:/src/pages/Home/sections/ClientExperiences.tsx|sig:5uvbhj" data-ast-start="6231" data-ast-end="6394">·</span>PROFECO Compliant<span className="mx-3 text-primary/70" data-ast-id="f:/src/pages/Home/sections/ClientExperiences.tsx|sig:5uvbhi" data-ast-start="6411" data-ast-end="6574">·</span>SAT Registered<span className="ml-3 text-primary" data-ast-id="f:/src/pages/Home/sections/ClientExperiences.tsx|sig:2kqx7v" data-ast-start="6588" data-ast-end="6748">—</span></p>
        </div>
      </div>
    </section>;
}